import { useMutation, useQueryClient } from '@tanstack/react-query';
import { sourcesApi } from '../api/sources.api';
import type { CreateSourceRequest } from '../types/sources.types';
import { sourceKeys } from './queryKeys';
import { Notification } from '@/shared/components/ahkinia/Notification/notification';

/**
 * React Query hook to create a new information source
 * Invalidates: ['sources'] queries on success
 *
 * @returns Mutation object with mutate, isPending, etc.
 */
export const useCreateSource = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: CreateSourceRequest) => sourcesApi.createSource(data),
    onSuccess: () => {
      // Invalidate all sources queries to refetch the list
      queryClient.invalidateQueries({ queryKey: sourceKeys.all });

      Notification.success({
        title: 'Fuente registrada',
        description:
          'La fuente ha sido registrada exitosamente. Se iniciará la sincronización según el intervalo configurado.',
      });
    },
  });
};
